<!-- NOTE: This component is deprecated and will be removed in the future -->
<!-- it is only used in dashboard filters, once we replace dashboard filters with filters component, this component will be removed  -->
<div class="form-field-wrapper flex flex-col w-[290px]">
  <mat-label>{{label}}</mat-label>
  <mat-form-field (click)="!disabled && picker.open()">
    <mat-date-range-input
      [rangePicker]="picker"
      [dateFilter]="dateFilter"
      [formGroup]="range"
      [max]="maxDate"
      [disabled]="disabled"
      [min]="minDate">
      <input matStartDate #dateRangeStart formControlName="start" readonly placeholder="{{'global.startDate' | translate}}" />
      <input
        matEndDate
        #dateRangeEnd
        formControlName="end"
        readonly
        placeholder="{{'global.endDate' | translate}}"
        (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)" />
    </mat-date-range-input>
    <div matSuffix class="flex flex-row items-center">
      <!-- Clear Button -->
      <button mat-icon-button type="button" (click)="clearDateRange($event)">
        <mat-icon>clear</mat-icon>
      </button>
      <mat-datepicker-toggle
        *ngIf="showClearBtn&&!range.controls.start.value &&!range.controls.end.value|| !showClearBtn"
        [disabled]="disabled"
        [for]="picker"></mat-datepicker-toggle>
    </div>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
</div>
